/**
 * Автоматично згенеровані маршрути (PRODUCTION MODE)
 * НЕ РЕДАГУЙТЕ ЦЕЙ ФАЙЛ ВРУЧНУ!
 * Генерується плагіном ViteKernelLoaderPlugin під час збірки
 */

import type { IRouteInfo } from '@/Core/Contracts/Loaders/IVitePluginGenerators'

import Component0 from '../src/Ship/Pages/IndexPage'
import Component1 from '../src/Containers/DiskSection/DiskAdminContainer/Pages/AuditPage'
import Component2 from '../src/Containers/DiskSection/DiskAdminContainer/Pages/IndexPage'
import Component3 from '../src/Containers/DiskSection/DiskAdminContainer/Pages/OffboardingPage'
import Component4 from '../src/Containers/DiskSection/DiskAdminContainer/Pages/PolicyPage'
import Component5 from '../src/Containers/DiskSection/DiskAdminContainer/Pages/StoragePage'
import Component6 from '../src/Containers/DiskSection/DiskAdminContainer/Pages/StoragesPage'
import Component7 from '../src/Containers/DiskSection/DiskContainer/Pages/BrowserPage'
import Component8 from '../src/Containers/DiskSection/DiskContainer/Pages/IndexPage'
import Component9 from '../src/Containers/DiskSection/DiskContainer/Pages/NodeLinkPage'
import Component10 from '../src/Containers/PublicSection/AuthContainer/Pages/ForgotPasswordPage'
import Component11 from '../src/Containers/PublicSection/AuthContainer/Pages/LoginPage'
import Component12 from '../src/Containers/PublicSection/ErrorContainer/Pages/Error404Page'
import Component13 from '../src/Containers/ReportSection/ReportContainer/Pages/ClientLossesPage'
import Component14 from '../src/Containers/ReportSection/ReportContainer/Pages/IndexPage'
import Component15 from '../src/Containers/ReportSection/ReportContainer/Pages/LogisticiansFinancialPage'
import Component16 from '../src/Containers/ReportSection/ReportContainer/Pages/LogisticiansInvolvementPage'
import Component17 from '../src/Containers/SettingSection/ListContainer/Pages/IndexPage'
import Component18 from '../src/Containers/SettingSection/ProfileContainer/Pages/ProfilePage'
import Component19 from '../src/Containers/SettingSection/UserContainer/Pages/UserInactivePage'
import Component20 from '../src/Containers/SettingSection/UserContainer/Pages/UserPage'
import Component21 from '../src/Containers/TaskSection/TaskContainer/Pages/AllTasksPage'
import Component22 from '../src/Containers/TaskSection/TaskContainer/Pages/AssignedTasksPage'
import Component23 from '../src/Containers/TaskSection/TaskContainer/Pages/MyTasksPage'
import Component24 from '../src/Containers/TaskSection/TaskContainer/Pages/RemovedTasksPage'
import Component25 from '../src/Core/Components/Resource/UniversalResourcePage'
import Component26 from '../src/Core/Components/Resource/UniversalResourcePage'
import Component27 from '../src/Core/Components/Resource/UniversalResourcePage'
import Component28 from '../src/Core/Components/Resource/UniversalResourcePage'
import Component29 from '../src/Core/Components/Resource/UniversalResourcePage'
import Component30 from '../src/Core/Components/Resource/UniversalResourcePage'
import Component31 from '../src/Core/Components/Resource/UniversalResourcePage'
import Component32 from '../src/Core/Components/Resource/UniversalResourcePage'
import Component33 from '../src/Core/Components/Resource/UniversalResourcePage'
import Component34 from '../src/Core/Components/Resource/UniversalResourcePage'
import Component35 from '../src/Core/Components/Resource/UniversalResourcePage'
import Component36 from '../src/Core/Components/Resource/UniversalResourcePage'
import Component37 from '../src/Core/Components/Resource/UniversalResourcePage'
import Component38 from '../src/Core/Components/Resource/UniversalResourcePage'
import Component39 from '../src/Core/Components/Resource/UniversalResourcePage'
import Component40 from '../src/Core/Components/Resource/UniversalResourcePage'
import Component41 from '../src/Core/Components/Resource/UniversalResourcePage'
import Component42 from '../src/Core/Components/Resource/UniversalResourcePage'
import Component43 from '../src/Core/Components/Resource/UniversalResourcePage'
import Component44 from '../src/Core/Components/Resource/UniversalResourcePage'
import Component45 from '../src/Core/Components/Resource/UniversalResourcePage'
import Component46 from '../src/Core/Components/Resource/UniversalResourcePage'
import Component47 from '../src/Core/Components/Resource/UniversalResourcePage'
import Component48 from '../src/Core/Components/Resource/UniversalResourcePage'
import Component49 from '../src/Core/Components/Resource/UniversalResourcePage'
import Component50 from '../src/Core/Components/Resource/UniversalResourcePage'
import Component51 from '../src/Core/Components/Resource/UniversalResourcePage'
import Component52 from '../src/Core/Components/Resource/UniversalResourcePage'
import Component53 from '../src/Core/Components/Resource/UniversalResourcePage'
import Component54 from '../src/Core/Components/Resource/UniversalResourcePage'
import Component55 from '../src/Core/Components/Resource/UniversalResourcePage'
import Component56 from '../src/Core/Components/Resource/UniversalResourcePage'
import Component57 from '../src/Core/Components/Resource/UniversalResourcePage'
import Component58 from '../src/Core/Components/Resource/UniversalResourcePage'
import Component59 from '../src/Core/Components/Resource/UniversalResourcePage'
import Component60 from '../src/Core/Components/Resource/UniversalResourcePage'
import Component61 from '../src/Core/Components/Resource/UniversalResourcePage'
import Component62 from '../src/Core/Components/Resource/UniversalResourcePage'
import Component63 from '../src/Core/Components/Resource/UniversalResourcePage'
import Component64 from '../src/Core/Components/Resource/UniversalResourcePage'
import Component65 from '../src/Core/Components/Resource/UniversalResourcePage'
import Component66 from '../src/Core/Components/Resource/UniversalResourcePage'
import Component67 from '../src/Core/Components/Resource/UniversalResourcePage'
import Component68 from '../src/Core/Components/Resource/UniversalResourcePage'
import Component69 from '../src/Core/Components/Resource/UniversalResourcePage'
import Component70 from '../src/Core/Components/Resource/UniversalResourcePage'
import Component71 from '../src/Core/Components/Resource/UniversalResourcePage'
import Component72 from '../src/Core/Components/Resource/UniversalResourcePage'
import Component73 from '../src/Core/Components/Resource/UniversalResourcePage'
import Component74 from '../src/Core/Components/Resource/UniversalResourcePage'
import Component75 from '../src/Core/Components/Resource/UniversalResourcePage'
import Component76 from '../src/Core/Components/Resource/UniversalResourcePage'
import Component77 from '../src/Core/Components/Resource/UniversalResourcePage'
import Component78 from '../src/Core/Components/Resource/UniversalResourcePage'
import Component79 from '../src/Core/Components/Resource/UniversalResourcePage'
import Component80 from '../src/Core/Components/Resource/UniversalResourcePage'
import Component81 from '../src/Core/Components/Resource/UniversalResourcePage'
import Component82 from '../src/Core/Components/Resource/UniversalResourcePage'
import Component83 from '../src/Core/Components/Resource/UniversalResourcePage'
import Component84 from '../src/Core/Components/Resource/UniversalResourcePage'
import Component85 from '../src/Core/Components/Resource/UniversalResourcePage'
import Component86 from '../src/Core/Components/Resource/UniversalResourcePage'
import Component87 from '../src/Core/Components/Resource/UniversalResourcePage'
import Component88 from '../src/Core/Components/Resource/UniversalResourcePage'
import Component89 from '../src/Core/Components/Resource/UniversalResourcePage'
import Component90 from '../src/Core/Components/Resource/UniversalResourcePage'
import Component91 from '../src/Core/Components/Resource/UniversalResourcePage'
import Component92 from '../src/Core/Components/Resource/UniversalResourcePage'
import Component93 from '../src/Core/Components/Resource/UniversalResourcePage'
import Component94 from '../src/Core/Components/Resource/UniversalResourcePage'
import Component95 from '../src/Core/Components/Resource/UniversalResourcePage'
import Component96 from '../src/Core/Components/Resource/UniversalResourcePage'
import Component97 from '../src/Core/Components/Resource/UniversalResourcePage'
import Component98 from '../src/Core/Components/Resource/UniversalResourcePage'
import Component99 from '../src/Core/Components/Resource/UniversalResourcePage'
import Component100 from '../src/Core/Components/Resource/UniversalResourcePage'
import Component101 from '../src/Core/Components/Resource/UniversalResourcePage'
import Component102 from '../src/Core/Components/Resource/UniversalResourcePage'
import Component103 from '../src/Core/Components/Resource/UniversalResourcePage'
import Component104 from '../src/Core/Components/Resource/UniversalResourcePage'
import Component105 from '../src/Core/Components/Resource/UniversalResourcePage'
import Component106 from '../src/Core/Components/Resource/UniversalResourcePage'
import Component107 from '../src/Core/Components/Resource/UniversalResourcePage'
import Component108 from '../src/Core/Components/Resource/UniversalResourcePage'
import Component109 from '../src/Core/Components/Resource/UniversalResourcePage'
import Component110 from '../src/Core/Components/Resource/UniversalResourcePage'
import Component111 from '../src/Core/Components/Resource/UniversalResourcePage'
import Component112 from '../src/Core/Components/Resource/UniversalResourcePage'
import Component113 from '../src/Core/Components/Resource/UniversalResourcePage'
import Component114 from '../src/Core/Components/Resource/UniversalResourcePage'
import Component115 from '../src/Core/Components/Resource/UniversalResourcePage'
import Component116 from '../src/Core/Components/Resource/UniversalResourcePage'
import Component117 from '../src/Core/Components/Resource/UniversalResourcePage'
import Component118 from '../src/Core/Components/Resource/UniversalResourcePage'
import Component119 from '../src/Core/Components/Resource/UniversalResourcePage'
import Component120 from '../src/Core/Components/Resource/UniversalResourcePage'
import Component121 from '../src/Core/Components/Resource/UniversalResourcePage'
import Component122 from '../src/Core/Components/Resource/UniversalResourcePage'
import Component123 from '../src/Core/Components/Resource/UniversalResourcePage'
import Component124 from '../src/Core/Components/Resource/UniversalResourcePage'
import Component125 from '../src/Core/Components/Resource/UniversalResourcePage'
import Component126 from '../src/Core/Components/Resource/UniversalResourcePage'
import Component127 from '../src/Core/Components/Resource/UniversalResourcePage'
import Component128 from '../src/Core/Components/Resource/UniversalResourcePage'
import Component129 from '../src/Core/Components/Resource/UniversalResourcePage'
import Component130 from '../src/Core/Components/Resource/UniversalResourcePage'
import Component131 from '../src/Core/Components/Resource/UniversalResourcePage'
import Component132 from '../src/Core/Components/Resource/UniversalResourcePage'
import Component133 from '../src/Core/Components/Resource/UniversalResourcePage'
import Component134 from '../src/Core/Components/Resource/UniversalResourcePage'
import Component135 from '../src/Core/Components/Resource/UniversalResourcePage'
import Component136 from '../src/Core/Components/Resource/UniversalResourcePage'
import Component137 from '../src/Core/Components/Resource/UniversalResourcePage'
import Component138 from '../src/Core/Components/Resource/UniversalResourcePage'
import Component139 from '../src/Core/Components/Resource/UniversalResourcePage'
import Component140 from '../src/Core/Components/Resource/UniversalResourcePage'
import Component141 from '../src/Core/Components/Resource/UniversalResourcePage'
import Component142 from '../src/Core/Components/Resource/UniversalResourcePage'
import Component143 from '../src/Core/Components/Resource/UniversalResourcePage'
import Component144 from '../src/Core/Components/Resource/UniversalResourcePage'
import Component145 from '../src/Core/Components/Resource/UniversalResourcePage'
import Component146 from '../src/Core/Components/Resource/UniversalResourcePage'
import Component147 from '../src/Core/Components/Resource/UniversalResourcePage'
import Component148 from '../src/Core/Components/Resource/UniversalResourcePage'
import Component149 from '../src/Core/Components/Resource/UniversalResourcePage'
import Component150 from '../src/Core/Components/Resource/UniversalResourcePage'
import Component151 from '../src/Core/Components/Resource/UniversalResourcePage'
import Component152 from '../src/Core/Components/Resource/UniversalResourcePage'

export const generatedRoutes: (IRouteInfo & { component: any })[] = [
  {
    path: "/",
    componentName: "IndexPage",
    key: "Index",
    group: "ship",
    template: "default",
    isIndex: true,
    config: {
      "title": "Index",
      "layout": "default"
    },
    component: Component0
  },
  {
    path: "/disk/admin/audit",
    componentName: "AuditPage",
    key: "Disk.Audit",
    section: "disk",
    container: "disk-admin",
    group: "container",
    template: "default",
    isIndex: false,
    config: {
      "title": "Audit",
      "layout": "default"
    },
    component: Component1
  },
  {
    path: "/disk/admin",
    componentName: "IndexPage",
    key: "Disk.Index",
    section: "disk",
    container: "disk-admin",
    group: "container",
    template: "default",
    isIndex: true,
    config: {
      "title": "Index",
      "layout": "default"
    },
    component: Component2
  },
  {
    path: "/disk/admin/offboarding/:uuid",
    componentName: "OffboardingPage",
    key: "Disk.Offboarding",
    section: "disk",
    container: "disk-admin",
    group: "container",
    template: "default",
    isIndex: false,
    config: {
      "title": "Offboarding",
      "layout": "default"
    },
    component: Component3
  },
  {
    path: "/disk/admin/policy",
    componentName: "PolicyPage",
    key: "Disk.Policy",
    section: "disk",
    container: "disk-admin",
    group: "container",
    template: "default",
    isIndex: false,
    config: {
      "title": "Policy",
      "layout": "default"
    },
    component: Component4
  },
  {
    path: "/disk/admin/storage/:id",
    componentName: "StoragePage",
    key: "Disk.Storage",
    section: "disk",
    container: "disk-admin",
    group: "container",
    template: "default",
    isIndex: false,
    config: {
      "title": "Storage",
      "layout": "default"
    },
    component: Component5
  },
  {
    path: "/disk/admin/storages",
    componentName: "StoragesPage",
    key: "Disk.Storages",
    section: "disk",
    container: "disk-admin",
    group: "container",
    template: "default",
    isIndex: false,
    config: {
      "title": "Storages",
      "layout": "default"
    },
    component: Component6
  },
  {
    path: "/disk/:storage/:folder?",
    componentName: "BrowserPage",
    key: "Disk.Browser",
    section: "disk",
    container: "disk",
    group: "container",
    template: "default",
    isIndex: false,
    config: {
      "title": "Browser",
      "layout": "default"
    },
    component: Component7
  },
  {
    path: "/disk",
    componentName: "IndexPage",
    key: "Disk.Index",
    section: "disk",
    container: "disk",
    group: "container",
    template: "default",
    isIndex: true,
    config: {
      "title": "Index",
      "layout": "default"
    },
    component: Component8
  },
  {
    path: "/disk/node/:uuid",
    componentName: "NodeLinkPage",
    key: "Disk.NodeLink",
    section: "disk",
    container: "disk",
    group: "container",
    template: "default",
    isIndex: false,
    config: {
      "title": "NodeLink",
      "layout": "default"
    },
    component: Component9
  },
  {
    path: "/public/forgot-password",
    componentName: "ForgotPasswordPage",
    key: "Public.ForgotPassword",
    section: "public",
    container: "auth",
    group: "container",
    template: "public",
    isIndex: false,
    config: {
      "title": "ForgotPassword",
      "layout": "public"
    },
    component: Component10
  },
  {
    path: "/public/login",
    componentName: "LoginPage",
    key: "Public.Login",
    section: "public",
    container: "auth",
    group: "container",
    template: "public",
    isIndex: false,
    config: {
      "title": "Login",
      "layout": "public"
    },
    component: Component11
  },
  {
    path: "/public/error404",
    componentName: "Error404Page",
    key: "Public.Error404",
    section: "public",
    container: "error",
    group: "container",
    template: "public",
    isIndex: false,
    config: {
      "title": "Error404",
      "layout": "public"
    },
    component: Component12
  },
  {
    path: "/report/client-losses",
    componentName: "ClientLossesPage",
    key: "Report.ClientLosses",
    section: "report",
    container: "report",
    group: "container",
    template: "default",
    isIndex: false,
    config: {
      "title": "ClientLosses",
      "layout": "default"
    },
    component: Component13
  },
  {
    path: "/report",
    componentName: "IndexPage",
    key: "Report.Index",
    section: "report",
    container: "report",
    group: "container",
    template: "default",
    isIndex: true,
    config: {
      "title": "Index",
      "layout": "default"
    },
    component: Component14
  },
  {
    path: "/report/logisticians-financial",
    componentName: "LogisticiansFinancialPage",
    key: "Report.LogisticiansFinancial",
    section: "report",
    container: "report",
    group: "container",
    template: "default",
    isIndex: false,
    config: {
      "title": "LogisticiansFinancial",
      "layout": "default"
    },
    component: Component15
  },
  {
    path: "/report/logisticians-involvement",
    componentName: "LogisticiansInvolvementPage",
    key: "Report.LogisticiansInvolvement",
    section: "report",
    container: "report",
    group: "container",
    template: "default",
    isIndex: false,
    config: {
      "title": "LogisticiansInvolvement",
      "layout": "default"
    },
    component: Component16
  },
  {
    path: "/settings",
    componentName: "IndexPage",
    key: "Setting.Index",
    section: "setting",
    container: "list",
    group: "container",
    template: "default",
    isIndex: true,
    config: {
      "title": "Index",
      "layout": "default"
    },
    component: Component17
  },
  {
    path: "/profile",
    componentName: "ProfilePage",
    key: "Setting.Profile",
    section: "setting",
    container: "profile",
    group: "container",
    template: "default",
    isIndex: false,
    config: {
      "title": "Profile",
      "layout": "default"
    },
    component: Component18
  },
  {
    path: "/users/inactive",
    componentName: "UserInactivePage",
    key: "Setting.UserInactive",
    section: "setting",
    container: "user",
    group: "container",
    template: "default",
    isIndex: false,
    config: {
      "title": "UserInactive",
      "layout": "default"
    },
    component: Component19
  },
  {
    path: "/users",
    componentName: "UserPage",
    key: "Setting.User",
    section: "setting",
    container: "user",
    group: "container",
    template: "default",
    isIndex: false,
    config: {
      "title": "User",
      "layout": "default"
    },
    component: Component20
  },
  {
    path: "/task/all-tasks",
    componentName: "AllTasksPage",
    key: "Task.AllTasks",
    section: "task",
    container: "task",
    group: "container",
    template: "default",
    isIndex: false,
    config: {
      "title": "AllTasks",
      "layout": "default"
    },
    component: Component21
  },
  {
    path: "/task/assigned-tasks",
    componentName: "AssignedTasksPage",
    key: "Task.AssignedTasks",
    section: "task",
    container: "task",
    group: "container",
    template: "default",
    isIndex: false,
    config: {
      "title": "AssignedTasks",
      "layout": "default"
    },
    component: Component22
  },
  {
    path: "/task/my-tasks",
    componentName: "MyTasksPage",
    key: "Task.MyTasks",
    section: "task",
    container: "task",
    group: "container",
    template: "default",
    isIndex: false,
    config: {
      "title": "MyTasks",
      "layout": "default"
    },
    component: Component23
  },
  {
    path: "/task/removed-tasks",
    componentName: "RemovedTasksPage",
    key: "Task.RemovedTasks",
    section: "task",
    container: "task",
    group: "container",
    template: "default",
    isIndex: false,
    config: {
      "title": "RemovedTasks",
      "layout": "default"
    },
    component: Component24
  },
  {
    path: "/activities",
    componentName: "UniversalResourcePage",
    key: "Crm.Activity",
    group: "resource",
    template: "default",
    isResourceGenerated: true,
    config: {
      "title": "Справи - Список",
      "layout": "default",
      "resourceKey": "Crm.Activity"
    },
    component: Component25
  },
  {
    path: "/activities/create",
    componentName: "UniversalResourcePage",
    key: "Crm.Activity.create",
    group: "resource",
    template: "default",
    isResourceGenerated: true,
    config: {
      "title": "Справи - Створити",
      "layout": "default",
      "resourceKey": "Crm.Activity"
    },
    component: Component26
  },
  {
    path: "/activities/:id",
    componentName: "UniversalResourcePage",
    key: "Crm.Activity.view",
    group: "resource",
    template: "default",
    isResourceGenerated: true,
    config: {
      "title": "Справи - Перегляд",
      "layout": "default",
      "resourceKey": "Crm.Activity"
    },
    component: Component27
  },
  {
    path: "/activities/:id/edit",
    componentName: "UniversalResourcePage",
    key: "Crm.Activity.edit",
    group: "resource",
    template: "default",
    isResourceGenerated: true,
    config: {
      "title": "Справи - Редагувати",
      "layout": "default",
      "resourceKey": "Crm.Activity"
    },
    component: Component28
  },
  {
    path: "/carriers",
    componentName: "UniversalResourcePage",
    key: "Crm.Carrier",
    group: "resource",
    template: "default",
    isResourceGenerated: true,
    config: {
      "title": "Перевізники - Список",
      "layout": "default",
      "resourceKey": "Crm.Carrier"
    },
    component: Component29
  },
  {
    path: "/carriers/create",
    componentName: "UniversalResourcePage",
    key: "Crm.Carrier.create",
    group: "resource",
    template: "default",
    isResourceGenerated: true,
    config: {
      "title": "Перевізники - Створити",
      "layout": "default",
      "resourceKey": "Crm.Carrier"
    },
    component: Component30
  },
  {
    path: "/carriers/:id",
    componentName: "UniversalResourcePage",
    key: "Crm.Carrier.view",
    group: "resource",
    template: "default",
    isResourceGenerated: true,
    config: {
      "title": "Перевізники - Перегляд",
      "layout": "default",
      "resourceKey": "Crm.Carrier"
    },
    component: Component31
  },
  {
    path: "/carriers/:id/edit",
    componentName: "UniversalResourcePage",
    key: "Crm.Carrier.edit",
    group: "resource",
    template: "default",
    isResourceGenerated: true,
    config: {
      "title": "Перевізники - Редагувати",
      "layout": "default",
      "resourceKey": "Crm.Carrier"
    },
    component: Component32
  },
  {
    path: "/clients",
    componentName: "UniversalResourcePage",
    key: "Crm.Client",
    group: "resource",
    template: "default",
    isResourceGenerated: true,
    config: {
      "title": "Клієнти - Список",
      "layout": "default",
      "resourceKey": "Crm.Client"
    },
    component: Component33
  },
  {
    path: "/clients/create",
    componentName: "UniversalResourcePage",
    key: "Crm.Client.create",
    group: "resource",
    template: "default",
    isResourceGenerated: true,
    config: {
      "title": "Клієнти - Створити",
      "layout": "default",
      "resourceKey": "Crm.Client"
    },
    component: Component34
  },
  {
    path: "/clients/:id",
    componentName: "UniversalResourcePage",
    key: "Crm.Client.view",
    group: "resource",
    template: "default",
    isResourceGenerated: true,
    config: {
      "title": "Клієнти - Перегляд",
      "layout": "default",
      "resourceKey": "Crm.Client"
    },
    component: Component35
  },
  {
    path: "/clients/:id/edit",
    componentName: "UniversalResourcePage",
    key: "Crm.Client.edit",
    group: "resource",
    template: "default",
    isResourceGenerated: true,
    config: {
      "title": "Клієнти - Редагувати",
      "layout": "default",
      "resourceKey": "Crm.Client"
    },
    component: Component36
  },
  {
    path: "/other-carriers",
    componentName: "UniversalResourcePage",
    key: "Crm.OtherCarrier",
    group: "resource",
    template: "default",
    isResourceGenerated: true,
    config: {
      "title": "Інші перевізники - Список",
      "layout": "default",
      "resourceKey": "Crm.OtherCarrier"
    },
    component: Component37
  },
  {
    path: "/other-carriers/create",
    componentName: "UniversalResourcePage",
    key: "Crm.OtherCarrier.create",
    group: "resource",
    template: "default",
    isResourceGenerated: true,
    config: {
      "title": "Інші перевізники - Створити",
      "layout": "default",
      "resourceKey": "Crm.OtherCarrier"
    },
    component: Component38
  },
  {
    path: "/other-carriers/:id",
    componentName: "UniversalResourcePage",
    key: "Crm.OtherCarrier.view",
    group: "resource",
    template: "default",
    isResourceGenerated: true,
    config: {
      "title": "Інші перевізники - Перегляд",
      "layout": "default",
      "resourceKey": "Crm.OtherCarrier"
    },
    component: Component39
  },
  {
    path: "/other-carriers/:id/edit",
    componentName: "UniversalResourcePage",
    key: "Crm.OtherCarrier.edit",
    group: "resource",
    template: "default",
    isResourceGenerated: true,
    config: {
      "title": "Інші перевізники - Редагувати",
      "layout": "default",
      "resourceKey": "Crm.OtherCarrier"
    },
    component: Component40
  },
  {
    path: "/departments",
    componentName: "UniversalResourcePage",
    key: "Setting.Department",
    group: "resource",
    template: "default",
    isResourceGenerated: true,
    config: {
      "title": "Структура компанії - Список",
      "layout": "default",
      "resourceKey": "Setting.Department"
    },
    component: Component41
  },
  {
    path: "/departments/create",
    componentName: "UniversalResourcePage",
    key: "Setting.Department.create",
    group: "resource",
    template: "default",
    isResourceGenerated: true,
    config: {
      "title": "Структура компанії - Створити",
      "layout": "default",
      "resourceKey": "Setting.Department"
    },
    component: Component42
  },
  {
    path: "/departments/:id",
    componentName: "UniversalResourcePage",
    key: "Setting.Department.view",
    group: "resource",
    template: "default",
    isResourceGenerated: true,
    config: {
      "title": "Структура компанії - Перегляд",
      "layout": "default",
      "resourceKey": "Setting.Department"
    },
    component: Component43
  },
  {
    path: "/departments/:id/edit",
    componentName: "UniversalResourcePage",
    key: "Setting.Department.edit",
    group: "resource",
    template: "default",
    isResourceGenerated: true,
    config: {
      "title": "Структура компанії - Редагувати",
      "layout": "default",
      "resourceKey": "Setting.Department"
    },
    component: Component44
  },
  {
    path: "/settings/activity-statuses",
    componentName: "UniversalResourcePage",
    key: "Setting.ListActivityStatus",
    group: "resource",
    template: "default",
    isResourceGenerated: true,
    config: {
      "title": "Статуси справ - Список",
      "layout": "default",
      "resourceKey": "Setting.ListActivityStatus"
    },
    component: Component45
  },
  {
    path: "/settings/activity-statuses/create",
    componentName: "UniversalResourcePage",
    key: "Setting.ListActivityStatus.create",
    group: "resource",
    template: "default",
    isResourceGenerated: true,
    config: {
      "title": "Статуси справ - Створити",
      "layout": "default",
      "resourceKey": "Setting.ListActivityStatus"
    },
    component: Component46
  },
  {
    path: "/settings/activity-statuses/:id",
    componentName: "UniversalResourcePage",
    key: "Setting.ListActivityStatus.view",
    group: "resource",
    template: "default",
    isResourceGenerated: true,
    config: {
      "title": "Статуси справ - Перегляд",
      "layout": "default",
      "resourceKey": "Setting.ListActivityStatus"
    },
    component: Component47
  },
  {
    path: "/settings/activity-statuses/:id/edit",
    componentName: "UniversalResourcePage",
    key: "Setting.ListActivityStatus.edit",
    group: "resource",
    template: "default",
    isResourceGenerated: true,
    config: {
      "title": "Статуси справ - Редагувати",
      "layout": "default",
      "resourceKey": "Setting.ListActivityStatus"
    },
    component: Component48
  },
  {
    path: "/settings/activity-types",
    componentName: "UniversalResourcePage",
    key: "Setting.ListActivityType",
    group: "resource",
    template: "default",
    isResourceGenerated: true,
    config: {
      "title": "Типи справ - Список",
      "layout": "default",
      "resourceKey": "Setting.ListActivityType"
    },
    component: Component49
  },
  {
    path: "/settings/activity-types/create",
    componentName: "UniversalResourcePage",
    key: "Setting.ListActivityType.create",
    group: "resource",
    template: "default",
    isResourceGenerated: true,
    config: {
      "title": "Типи справ - Створити",
      "layout": "default",
      "resourceKey": "Setting.ListActivityType"
    },
    component: Component50
  },
  {
    path: "/settings/activity-types/:id",
    componentName: "UniversalResourcePage",
    key: "Setting.ListActivityType.view",
    group: "resource",
    template: "default",
    isResourceGenerated: true,
    config: {
      "title": "Типи справ - Перегляд",
      "layout": "default",
      "resourceKey": "Setting.ListActivityType"
    },
    component: Component51
  },
  {
    path: "/settings/activity-types/:id/edit",
    componentName: "UniversalResourcePage",
    key: "Setting.ListActivityType.edit",
    group: "resource",
    template: "default",
    isResourceGenerated: true,
    config: {
      "title": "Типи справ - Редагувати",
      "layout": "default",
      "resourceKey": "Setting.ListActivityType"
    },
    component: Component52
  },
  {
    path: "/settings/application-loss-reasons",
    componentName: "UniversalResourcePage",
    key: "Setting.ListApplicationLossReason",
    group: "resource",
    template: "default",
    isResourceGenerated: true,
    config: {
      "title": "Причини програшу заявок - Список",
      "layout": "default",
      "resourceKey": "Setting.ListApplicationLossReason"
    },
    component: Component53
  },
  {
    path: "/settings/application-loss-reasons/create",
    componentName: "UniversalResourcePage",
    key: "Setting.ListApplicationLossReason.create",
    group: "resource",
    template: "default",
    isResourceGenerated: true,
    config: {
      "title": "Причини програшу заявок - Створити",
      "layout": "default",
      "resourceKey": "Setting.ListApplicationLossReason"
    },
    component: Component54
  },
  {
    path: "/settings/application-loss-reasons/:id",
    componentName: "UniversalResourcePage",
    key: "Setting.ListApplicationLossReason.view",
    group: "resource",
    template: "default",
    isResourceGenerated: true,
    config: {
      "title": "Причини програшу заявок - Перегляд",
      "layout": "default",
      "resourceKey": "Setting.ListApplicationLossReason"
    },
    component: Component55
  },
  {
    path: "/settings/application-loss-reasons/:id/edit",
    componentName: "UniversalResourcePage",
    key: "Setting.ListApplicationLossReason.edit",
    group: "resource",
    template: "default",
    isResourceGenerated: true,
    config: {
      "title": "Причини програшу заявок - Редагувати",
      "layout": "default",
      "resourceKey": "Setting.ListApplicationLossReason"
    },
    component: Component56
  },
  {
    path: "/settings/application-statuses",
    componentName: "UniversalResourcePage",
    key: "Setting.ListApplicationStatus",
    group: "resource",
    template: "default",
    isResourceGenerated: true,
    config: {
      "title": "Статуси заявок - Список",
      "layout": "default",
      "resourceKey": "Setting.ListApplicationStatus"
    },
    component: Component57
  },
  {
    path: "/settings/application-statuses/create",
    componentName: "UniversalResourcePage",
    key: "Setting.ListApplicationStatus.create",
    group: "resource",
    template: "default",
    isResourceGenerated: true,
    config: {
      "title": "Статуси заявок - Створити",
      "layout": "default",
      "resourceKey": "Setting.ListApplicationStatus"
    },
    component: Component58
  },
  {
    path: "/settings/application-statuses/:id",
    componentName: "UniversalResourcePage",
    key: "Setting.ListApplicationStatus.view",
    group: "resource",
    template: "default",
    isResourceGenerated: true,
    config: {
      "title": "Статуси заявок - Перегляд",
      "layout": "default",
      "resourceKey": "Setting.ListApplicationStatus"
    },
    component: Component59
  },
  {
    path: "/settings/application-statuses/:id/edit",
    componentName: "UniversalResourcePage",
    key: "Setting.ListApplicationStatus.edit",
    group: "resource",
    template: "default",
    isResourceGenerated: true,
    config: {
      "title": "Статуси заявок - Редагувати",
      "layout": "default",
      "resourceKey": "Setting.ListApplicationStatus"
    },
    component: Component60
  },
  {
    path: "/settings/border-crossings",
    componentName: "UniversalResourcePage",
    key: "Setting.ListBorderCrossing",
    group: "resource",
    template: "default",
    isResourceGenerated: true,
    config: {
      "title": "Прикордонні переходи - Список",
      "layout": "default",
      "resourceKey": "Setting.ListBorderCrossing"
    },
    component: Component61
  },
  {
    path: "/settings/border-crossings/create",
    componentName: "UniversalResourcePage",
    key: "Setting.ListBorderCrossing.create",
    group: "resource",
    template: "default",
    isResourceGenerated: true,
    config: {
      "title": "Прикордонні переходи - Створити",
      "layout": "default",
      "resourceKey": "Setting.ListBorderCrossing"
    },
    component: Component62
  },
  {
    path: "/settings/border-crossings/:id",
    componentName: "UniversalResourcePage",
    key: "Setting.ListBorderCrossing.view",
    group: "resource",
    template: "default",
    isResourceGenerated: true,
    config: {
      "title": "Прикордонні переходи - Перегляд",
      "layout": "default",
      "resourceKey": "Setting.ListBorderCrossing"
    },
    component: Component63
  },
  {
    path: "/settings/border-crossings/:id/edit",
    componentName: "UniversalResourcePage",
    key: "Setting.ListBorderCrossing.edit",
    group: "resource",
    template: "default",
    isResourceGenerated: true,
    config: {
      "title": "Прикордонні переходи - Редагувати",
      "layout": "default",
      "resourceKey": "Setting.ListBorderCrossing"
    },
    component: Component64
  },
  {
    path: "/settings/car-ownership-types",
    componentName: "UniversalResourcePage",
    key: "Setting.ListCarOwnershipType",
    group: "resource",
    template: "default",
    isResourceGenerated: true,
    config: {
      "title": "Типи власності авто - Список",
      "layout": "default",
      "resourceKey": "Setting.ListCarOwnershipType"
    },
    component: Component65
  },
  {
    path: "/settings/car-ownership-types/create",
    componentName: "UniversalResourcePage",
    key: "Setting.ListCarOwnershipType.create",
    group: "resource",
    template: "default",
    isResourceGenerated: true,
    config: {
      "title": "Типи власності авто - Створити",
      "layout": "default",
      "resourceKey": "Setting.ListCarOwnershipType"
    },
    component: Component66
  },
  {
    path: "/settings/car-ownership-types/:id",
    componentName: "UniversalResourcePage",
    key: "Setting.ListCarOwnershipType.view",
    group: "resource",
    template: "default",
    isResourceGenerated: true,
    config: {
      "title": "Типи власності авто - Перегляд",
      "layout": "default",
      "resourceKey": "Setting.ListCarOwnershipType"
    },
    component: Component67
  },
  {
    path: "/settings/car-ownership-types/:id/edit",
    componentName: "UniversalResourcePage",
    key: "Setting.ListCarOwnershipType.edit",
    group: "resource",
    template: "default",
    isResourceGenerated: true,
    config: {
      "title": "Типи власності авто - Редагувати",
      "layout": "default",
      "resourceKey": "Setting.ListCarOwnershipType"
    },
    component: Component68
  },
  {
    path: "/settings/car-park-sizes",
    componentName: "UniversalResourcePage",
    key: "Setting.ListCarParkSize",
    group: "resource",
    template: "default",
    isResourceGenerated: true,
    config: {
      "title": "Кількість транспортних засобів у парку - Список",
      "layout": "default",
      "resourceKey": "Setting.ListCarParkSize"
    },
    component: Component69
  },
  {
    path: "/settings/car-park-sizes/create",
    componentName: "UniversalResourcePage",
    key: "Setting.ListCarParkSize.create",
    group: "resource",
    template: "default",
    isResourceGenerated: true,
    config: {
      "title": "Кількість транспортних засобів у парку - Створити",
      "layout": "default",
      "resourceKey": "Setting.ListCarParkSize"
    },
    component: Component70
  },
  {
    path: "/settings/car-park-sizes/:id",
    componentName: "UniversalResourcePage",
    key: "Setting.ListCarParkSize.view",
    group: "resource",
    template: "default",
    isResourceGenerated: true,
    config: {
      "title": "Кількість транспортних засобів у парку - Перегляд",
      "layout": "default",
      "resourceKey": "Setting.ListCarParkSize"
    },
    component: Component71
  },
  {
    path: "/settings/car-park-sizes/:id/edit",
    componentName: "UniversalResourcePage",
    key: "Setting.ListCarParkSize.edit",
    group: "resource",
    template: "default",
    isResourceGenerated: true,
    config: {
      "title": "Кількість транспортних засобів у парку - Редагувати",
      "layout": "default",
      "resourceKey": "Setting.ListCarParkSize"
    },
    component: Component72
  },
  {
    path: "/settings/car-types",
    componentName: "UniversalResourcePage",
    key: "Setting.ListCarType",
    group: "resource",
    template: "default",
    isResourceGenerated: true,
    config: {
      "title": "Типи авто - Список",
      "layout": "default",
      "resourceKey": "Setting.ListCarType"
    },
    component: Component73
  },
  {
    path: "/settings/car-types/create",
    componentName: "UniversalResourcePage",
    key: "Setting.ListCarType.create",
    group: "resource",
    template: "default",
    isResourceGenerated: true,
    config: {
      "title": "Типи авто - Створити",
      "layout": "default",
      "resourceKey": "Setting.ListCarType"
    },
    component: Component74
  },
  {
    path: "/settings/car-types/:id",
    componentName: "UniversalResourcePage",
    key: "Setting.ListCarType.view",
    group: "resource",
    template: "default",
    isResourceGenerated: true,
    config: {
      "title": "Типи авто - Перегляд",
      "layout": "default",
      "resourceKey": "Setting.ListCarType"
    },
    component: Component75
  },
  {
    path: "/settings/car-types/:id/edit",
    componentName: "UniversalResourcePage",
    key: "Setting.ListCarType.edit",
    group: "resource",
    template: "default",
    isResourceGenerated: true,
    config: {
      "title": "Типи авто - Редагувати",
      "layout": "default",
      "resourceKey": "Setting.ListCarType"
    },
    component: Component76
  },
  {
    path: "/settings/carrier-statuses",
    componentName: "UniversalResourcePage",
    key: "Setting.ListCarrierStatus",
    group: "resource",
    template: "default",
    isResourceGenerated: true,
    config: {
      "title": "Статуси перевізників - Список",
      "layout": "default",
      "resourceKey": "Setting.ListCarrierStatus"
    },
    component: Component77
  },
  {
    path: "/settings/carrier-statuses/create",
    componentName: "UniversalResourcePage",
    key: "Setting.ListCarrierStatus.create",
    group: "resource",
    template: "default",
    isResourceGenerated: true,
    config: {
      "title": "Статуси перевізників - Створити",
      "layout": "default",
      "resourceKey": "Setting.ListCarrierStatus"
    },
    component: Component78
  },
  {
    path: "/settings/carrier-statuses/:id",
    componentName: "UniversalResourcePage",
    key: "Setting.ListCarrierStatus.view",
    group: "resource",
    template: "default",
    isResourceGenerated: true,
    config: {
      "title": "Статуси перевізників - Перегляд",
      "layout": "default",
      "resourceKey": "Setting.ListCarrierStatus"
    },
    component: Component79
  },
  {
    path: "/settings/carrier-statuses/:id/edit",
    componentName: "UniversalResourcePage",
    key: "Setting.ListCarrierStatus.edit",
    group: "resource",
    template: "default",
    isResourceGenerated: true,
    config: {
      "title": "Статуси перевізників - Редагувати",
      "layout": "default",
      "resourceKey": "Setting.ListCarrierStatus"
    },
    component: Component80
  },
  {
    path: "/settings/client-statuses",
    componentName: "UniversalResourcePage",
    key: "Setting.ListClientStatus",
    group: "resource",
    template: "default",
    isResourceGenerated: true,
    config: {
      "title": "Статуси клієнтів - Список",
      "layout": "default",
      "resourceKey": "Setting.ListClientStatus"
    },
    component: Component81
  },
  {
    path: "/settings/client-statuses/create",
    componentName: "UniversalResourcePage",
    key: "Setting.ListClientStatus.create",
    group: "resource",
    template: "default",
    isResourceGenerated: true,
    config: {
      "title": "Статуси клієнтів - Створити",
      "layout": "default",
      "resourceKey": "Setting.ListClientStatus"
    },
    component: Component82
  },
  {
    path: "/settings/client-statuses/:id",
    componentName: "UniversalResourcePage",
    key: "Setting.ListClientStatus.view",
    group: "resource",
    template: "default",
    isResourceGenerated: true,
    config: {
      "title": "Статуси клієнтів - Перегляд",
      "layout": "default",
      "resourceKey": "Setting.ListClientStatus"
    },
    component: Component83
  },
  {
    path: "/settings/client-statuses/:id/edit",
    componentName: "UniversalResourcePage",
    key: "Setting.ListClientStatus.edit",
    group: "resource",
    template: "default",
    isResourceGenerated: true,
    config: {
      "title": "Статуси клієнтів - Редагувати",
      "layout": "default",
      "resourceKey": "Setting.ListClientStatus"
    },
    component: Component84
  },
  {
    path: "/settings/countries",
    componentName: "UniversalResourcePage",
    key: "Setting.ListCountry",
    group: "resource",
    template: "default",
    isResourceGenerated: true,
    config: {
      "title": "Країни - Список",
      "layout": "default",
      "resourceKey": "Setting.ListCountry"
    },
    component: Component85
  },
  {
    path: "/settings/countries/create",
    componentName: "UniversalResourcePage",
    key: "Setting.ListCountry.create",
    group: "resource",
    template: "default",
    isResourceGenerated: true,
    config: {
      "title": "Країни - Створити",
      "layout": "default",
      "resourceKey": "Setting.ListCountry"
    },
    component: Component86
  },
  {
    path: "/settings/countries/:id",
    componentName: "UniversalResourcePage",
    key: "Setting.ListCountry.view",
    group: "resource",
    template: "default",
    isResourceGenerated: true,
    config: {
      "title": "Країни - Перегляд",
      "layout": "default",
      "resourceKey": "Setting.ListCountry"
    },
    component: Component87
  },
  {
    path: "/settings/countries/:id/edit",
    componentName: "UniversalResourcePage",
    key: "Setting.ListCountry.edit",
    group: "resource",
    template: "default",
    isResourceGenerated: true,
    config: {
      "title": "Країни - Редагувати",
      "layout": "default",
      "resourceKey": "Setting.ListCountry"
    },
    component: Component88
  },
  {
    path: "/settings/currency-rates",
    componentName: "UniversalResourcePage",
    key: "Setting.ListCurrencyRate",
    group: "resource",
    template: "default",
    isResourceGenerated: true,
    config: {
      "title": "Курси валют - Список",
      "layout": "default",
      "resourceKey": "Setting.ListCurrencyRate"
    },
    component: Component89
  },
  {
    path: "/settings/currency-rates/create",
    componentName: "UniversalResourcePage",
    key: "Setting.ListCurrencyRate.create",
    group: "resource",
    template: "default",
    isResourceGenerated: true,
    config: {
      "title": "Курси валют - Створити",
      "layout": "default",
      "resourceKey": "Setting.ListCurrencyRate"
    },
    component: Component90
  },
  {
    path: "/settings/currency-rates/:id",
    componentName: "UniversalResourcePage",
    key: "Setting.ListCurrencyRate.view",
    group: "resource",
    template: "default",
    isResourceGenerated: true,
    config: {
      "title": "Курси валют - Перегляд",
      "layout": "default",
      "resourceKey": "Setting.ListCurrencyRate"
    },
    component: Component91
  },
  {
    path: "/settings/currency-rates/:id/edit",
    componentName: "UniversalResourcePage",
    key: "Setting.ListCurrencyRate.edit",
    group: "resource",
    template: "default",
    isResourceGenerated: true,
    config: {
      "title": "Курси валют - Редагувати",
      "layout": "default",
      "resourceKey": "Setting.ListCurrencyRate"
    },
    component: Component92
  },
  {
    path: "/settings/currencies",
    componentName: "UniversalResourcePage",
    key: "Setting.ListCurrency",
    group: "resource",
    template: "default",
    isResourceGenerated: true,
    config: {
      "title": "Валюти - Список",
      "layout": "default",
      "resourceKey": "Setting.ListCurrency"
    },
    component: Component93
  },
  {
    path: "/settings/currencies/create",
    componentName: "UniversalResourcePage",
    key: "Setting.ListCurrency.create",
    group: "resource",
    template: "default",
    isResourceGenerated: true,
    config: {
      "title": "Валюти - Створити",
      "layout": "default",
      "resourceKey": "Setting.ListCurrency"
    },
    component: Component94
  },
  {
    path: "/settings/currencies/:id",
    componentName: "UniversalResourcePage",
    key: "Setting.ListCurrency.view",
    group: "resource",
    template: "default",
    isResourceGenerated: true,
    config: {
      "title": "Валюти - Перегляд",
      "layout": "default",
      "resourceKey": "Setting.ListCurrency"
    },
    component: Component95
  },
  {
    path: "/settings/currencies/:id/edit",
    componentName: "UniversalResourcePage",
    key: "Setting.ListCurrency.edit",
    group: "resource",
    template: "default",
    isResourceGenerated: true,
    config: {
      "title": "Валюти - Редагувати",
      "layout": "default",
      "resourceKey": "Setting.ListCurrency"
    },
    component: Component96
  },
  {
    path: "/settings/forms-taxation",
    componentName: "UniversalResourcePage",
    key: "Setting.ListFormTaxation",
    group: "resource",
    template: "default",
    isResourceGenerated: true,
    config: {
      "title": "Форми оподаткування - Список",
      "layout": "default",
      "resourceKey": "Setting.ListFormTaxation"
    },
    component: Component97
  },
  {
    path: "/settings/forms-taxation/create",
    componentName: "UniversalResourcePage",
    key: "Setting.ListFormTaxation.create",
    group: "resource",
    template: "default",
    isResourceGenerated: true,
    config: {
      "title": "Форми оподаткування - Створити",
      "layout": "default",
      "resourceKey": "Setting.ListFormTaxation"
    },
    component: Component98
  },
  {
    path: "/settings/forms-taxation/:id",
    componentName: "UniversalResourcePage",
    key: "Setting.ListFormTaxation.view",
    group: "resource",
    template: "default",
    isResourceGenerated: true,
    config: {
      "title": "Форми оподаткування - Перегляд",
      "layout": "default",
      "resourceKey": "Setting.ListFormTaxation"
    },
    component: Component99
  },
  {
    path: "/settings/forms-taxation/:id/edit",
    componentName: "UniversalResourcePage",
    key: "Setting.ListFormTaxation.edit",
    group: "resource",
    template: "default",
    isResourceGenerated: true,
    config: {
      "title": "Форми оподаткування - Редагувати",
      "layout": "default",
      "resourceKey": "Setting.ListFormTaxation"
    },
    component: Component100
  },
  {
    path: "/settings/legal-entities",
    componentName: "UniversalResourcePage",
    key: "Setting.ListLegalEntity",
    group: "resource",
    template: "default",
    isResourceGenerated: true,
    config: {
      "title": "Юридичні особи - Список",
      "layout": "default",
      "resourceKey": "Setting.ListLegalEntity"
    },
    component: Component101
  },
  {
    path: "/settings/legal-entities/create",
    componentName: "UniversalResourcePage",
    key: "Setting.ListLegalEntity.create",
    group: "resource",
    template: "default",
    isResourceGenerated: true,
    config: {
      "title": "Юридичні особи - Створити",
      "layout": "default",
      "resourceKey": "Setting.ListLegalEntity"
    },
    component: Component102
  },
  {
    path: "/settings/legal-entities/:id",
    componentName: "UniversalResourcePage",
    key: "Setting.ListLegalEntity.view",
    group: "resource",
    template: "default",
    isResourceGenerated: true,
    config: {
      "title": "Юридичні особи - Перегляд",
      "layout": "default",
      "resourceKey": "Setting.ListLegalEntity"
    },
    component: Component103
  },
  {
    path: "/settings/legal-entities/:id/edit",
    componentName: "UniversalResourcePage",
    key: "Setting.ListLegalEntity.edit",
    group: "resource",
    template: "default",
    isResourceGenerated: true,
    config: {
      "title": "Юридичні особи - Редагувати",
      "layout": "default",
      "resourceKey": "Setting.ListLegalEntity"
    },
    component: Component104
  },
  {
    path: "/settings/letter-templates",
    componentName: "UniversalResourcePage",
    key: "Setting.ListLetterTemplate",
    group: "resource",
    template: "default",
    isResourceGenerated: true,
    config: {
      "title": "Шаблони листів - Список",
      "layout": "default",
      "resourceKey": "Setting.ListLetterTemplate"
    },
    component: Component105
  },
  {
    path: "/settings/letter-templates/create",
    componentName: "UniversalResourcePage",
    key: "Setting.ListLetterTemplate.create",
    group: "resource",
    template: "default",
    isResourceGenerated: true,
    config: {
      "title": "Шаблони листів - Створити",
      "layout": "default",
      "resourceKey": "Setting.ListLetterTemplate"
    },
    component: Component106
  },
  {
    path: "/settings/letter-templates/:id",
    componentName: "UniversalResourcePage",
    key: "Setting.ListLetterTemplate.view",
    group: "resource",
    template: "default",
    isResourceGenerated: true,
    config: {
      "title": "Шаблони листів - Перегляд",
      "layout": "default",
      "resourceKey": "Setting.ListLetterTemplate"
    },
    component: Component107
  },
  {
    path: "/settings/letter-templates/:id/edit",
    componentName: "UniversalResourcePage",
    key: "Setting.ListLetterTemplate.edit",
    group: "resource",
    template: "default",
    isResourceGenerated: true,
    config: {
      "title": "Шаблони листів - Редагувати",
      "layout": "default",
      "resourceKey": "Setting.ListLetterTemplate"
    },
    component: Component108
  },
  {
    path: "/settings/request-loss-reasons",
    componentName: "UniversalResourcePage",
    key: "Setting.ListRequestLossReason",
    group: "resource",
    template: "default",
    isResourceGenerated: true,
    config: {
      "title": "Причини програшу запитів - Список",
      "layout": "default",
      "resourceKey": "Setting.ListRequestLossReason"
    },
    component: Component109
  },
  {
    path: "/settings/request-loss-reasons/create",
    componentName: "UniversalResourcePage",
    key: "Setting.ListRequestLossReason.create",
    group: "resource",
    template: "default",
    isResourceGenerated: true,
    config: {
      "title": "Причини програшу запитів - Створити",
      "layout": "default",
      "resourceKey": "Setting.ListRequestLossReason"
    },
    component: Component110
  },
  {
    path: "/settings/request-loss-reasons/:id",
    componentName: "UniversalResourcePage",
    key: "Setting.ListRequestLossReason.view",
    group: "resource",
    template: "default",
    isResourceGenerated: true,
    config: {
      "title": "Причини програшу запитів - Перегляд",
      "layout": "default",
      "resourceKey": "Setting.ListRequestLossReason"
    },
    component: Component111
  },
  {
    path: "/settings/request-loss-reasons/:id/edit",
    componentName: "UniversalResourcePage",
    key: "Setting.ListRequestLossReason.edit",
    group: "resource",
    template: "default",
    isResourceGenerated: true,
    config: {
      "title": "Причини програшу запитів - Редагувати",
      "layout": "default",
      "resourceKey": "Setting.ListRequestLossReason"
    },
    component: Component112
  },
  {
    path: "/settings/request-statuses",
    componentName: "UniversalResourcePage",
    key: "Setting.ListRequestStatus",
    group: "resource",
    template: "default",
    isResourceGenerated: true,
    config: {
      "title": "Статуси запитів - Список",
      "layout": "default",
      "resourceKey": "Setting.ListRequestStatus"
    },
    component: Component113
  },
  {
    path: "/settings/request-statuses/create",
    componentName: "UniversalResourcePage",
    key: "Setting.ListRequestStatus.create",
    group: "resource",
    template: "default",
    isResourceGenerated: true,
    config: {
      "title": "Статуси запитів - Створити",
      "layout": "default",
      "resourceKey": "Setting.ListRequestStatus"
    },
    component: Component114
  },
  {
    path: "/settings/request-statuses/:id",
    componentName: "UniversalResourcePage",
    key: "Setting.ListRequestStatus.view",
    group: "resource",
    template: "default",
    isResourceGenerated: true,
    config: {
      "title": "Статуси запитів - Перегляд",
      "layout": "default",
      "resourceKey": "Setting.ListRequestStatus"
    },
    component: Component115
  },
  {
    path: "/settings/request-statuses/:id/edit",
    componentName: "UniversalResourcePage",
    key: "Setting.ListRequestStatus.edit",
    group: "resource",
    template: "default",
    isResourceGenerated: true,
    config: {
      "title": "Статуси запитів - Редагувати",
      "layout": "default",
      "resourceKey": "Setting.ListRequestStatus"
    },
    component: Component116
  },
  {
    path: "/settings/tender-loss-reasons",
    componentName: "UniversalResourcePage",
    key: "Setting.ListTenderLossReason",
    group: "resource",
    template: "default",
    isResourceGenerated: true,
    config: {
      "title": "Причини програшу тендерів - Список",
      "layout": "default",
      "resourceKey": "Setting.ListTenderLossReason"
    },
    component: Component117
  },
  {
    path: "/settings/tender-loss-reasons/create",
    componentName: "UniversalResourcePage",
    key: "Setting.ListTenderLossReason.create",
    group: "resource",
    template: "default",
    isResourceGenerated: true,
    config: {
      "title": "Причини програшу тендерів - Створити",
      "layout": "default",
      "resourceKey": "Setting.ListTenderLossReason"
    },
    component: Component118
  },
  {
    path: "/settings/tender-loss-reasons/:id",
    componentName: "UniversalResourcePage",
    key: "Setting.ListTenderLossReason.view",
    group: "resource",
    template: "default",
    isResourceGenerated: true,
    config: {
      "title": "Причини програшу тендерів - Перегляд",
      "layout": "default",
      "resourceKey": "Setting.ListTenderLossReason"
    },
    component: Component119
  },
  {
    path: "/settings/tender-loss-reasons/:id/edit",
    componentName: "UniversalResourcePage",
    key: "Setting.ListTenderLossReason.edit",
    group: "resource",
    template: "default",
    isResourceGenerated: true,
    config: {
      "title": "Причини програшу тендерів - Редагувати",
      "layout": "default",
      "resourceKey": "Setting.ListTenderLossReason"
    },
    component: Component120
  },
  {
    path: "/settings/tender-statuses",
    componentName: "UniversalResourcePage",
    key: "Setting.ListTenderStatus",
    group: "resource",
    template: "default",
    isResourceGenerated: true,
    config: {
      "title": "Статуси тендерів - Список",
      "layout": "default",
      "resourceKey": "Setting.ListTenderStatus"
    },
    component: Component121
  },
  {
    path: "/settings/tender-statuses/create",
    componentName: "UniversalResourcePage",
    key: "Setting.ListTenderStatus.create",
    group: "resource",
    template: "default",
    isResourceGenerated: true,
    config: {
      "title": "Статуси тендерів - Створити",
      "layout": "default",
      "resourceKey": "Setting.ListTenderStatus"
    },
    component: Component122
  },
  {
    path: "/settings/tender-statuses/:id",
    componentName: "UniversalResourcePage",
    key: "Setting.ListTenderStatus.view",
    group: "resource",
    template: "default",
    isResourceGenerated: true,
    config: {
      "title": "Статуси тендерів - Перегляд",
      "layout": "default",
      "resourceKey": "Setting.ListTenderStatus"
    },
    component: Component123
  },
  {
    path: "/settings/tender-statuses/:id/edit",
    componentName: "UniversalResourcePage",
    key: "Setting.ListTenderStatus.edit",
    group: "resource",
    template: "default",
    isResourceGenerated: true,
    config: {
      "title": "Статуси тендерів - Редагувати",
      "layout": "default",
      "resourceKey": "Setting.ListTenderStatus"
    },
    component: Component124
  },
  {
    path: "/settings/document-types",
    componentName: "UniversalResourcePage",
    key: "Setting.ListDocumentType",
    group: "resource",
    template: "default",
    isResourceGenerated: true,
    config: {
      "title": "Типи документів - Список",
      "layout": "default",
      "resourceKey": "Setting.ListDocumentType"
    },
    component: Component125
  },
  {
    path: "/settings/document-types/create",
    componentName: "UniversalResourcePage",
    key: "Setting.ListDocumentType.create",
    group: "resource",
    template: "default",
    isResourceGenerated: true,
    config: {
      "title": "Типи документів - Створити",
      "layout": "default",
      "resourceKey": "Setting.ListDocumentType"
    },
    component: Component126
  },
  {
    path: "/settings/document-types/:id",
    componentName: "UniversalResourcePage",
    key: "Setting.ListDocumentType.view",
    group: "resource",
    template: "default",
    isResourceGenerated: true,
    config: {
      "title": "Типи документів - Перегляд",
      "layout": "default",
      "resourceKey": "Setting.ListDocumentType"
    },
    component: Component127
  },
  {
    path: "/settings/document-types/:id/edit",
    componentName: "UniversalResourcePage",
    key: "Setting.ListDocumentType.edit",
    group: "resource",
    template: "default",
    isResourceGenerated: true,
    config: {
      "title": "Типи документів - Редагувати",
      "layout": "default",
      "resourceKey": "Setting.ListDocumentType"
    },
    component: Component128
  },
  {
    path: "/users",
    componentName: "UniversalResourcePage",
    key: "Setting.User",
    group: "resource",
    template: "default",
    isResourceGenerated: true,
    config: {
      "title": "Співробітники - Список",
      "layout": "default",
      "resourceKey": "Setting.User"
    },
    component: Component129
  },
  {
    path: "/users/create",
    componentName: "UniversalResourcePage",
    key: "Setting.User.create",
    group: "resource",
    template: "default",
    isResourceGenerated: true,
    config: {
      "title": "Співробітники - Створити",
      "layout": "default",
      "resourceKey": "Setting.User"
    },
    component: Component130
  },
  {
    path: "/users/:id",
    componentName: "UniversalResourcePage",
    key: "Setting.User.view",
    group: "resource",
    template: "default",
    isResourceGenerated: true,
    config: {
      "title": "Співробітники - Перегляд",
      "layout": "default",
      "resourceKey": "Setting.User"
    },
    component: Component131
  },
  {
    path: "/users/:id/edit",
    componentName: "UniversalResourcePage",
    key: "Setting.User.edit",
    group: "resource",
    template: "default",
    isResourceGenerated: true,
    config: {
      "title": "Співробітники - Редагувати",
      "layout": "default",
      "resourceKey": "Setting.User"
    },
    component: Component132
  },
  {
    path: "/tasks",
    componentName: "UniversalResourcePage",
    key: "Task.Task",
    group: "resource",
    template: "default",
    isResourceGenerated: true,
    config: {
      "title": "Завдання - Список",
      "layout": "default",
      "resourceKey": "Task.Task"
    },
    component: Component133
  },
  {
    path: "/tasks/create",
    componentName: "UniversalResourcePage",
    key: "Task.Task.create",
    group: "resource",
    template: "default",
    isResourceGenerated: true,
    config: {
      "title": "Завдання - Створити",
      "layout": "default",
      "resourceKey": "Task.Task"
    },
    component: Component134
  },
  {
    path: "/tasks/:id",
    componentName: "UniversalResourcePage",
    key: "Task.Task.view",
    group: "resource",
    template: "default",
    isResourceGenerated: true,
    config: {
      "title": "Завдання - Перегляд",
      "layout": "default",
      "resourceKey": "Task.Task"
    },
    component: Component135
  },
  {
    path: "/tasks/:id/edit",
    componentName: "UniversalResourcePage",
    key: "Task.Task.edit",
    group: "resource",
    template: "default",
    isResourceGenerated: true,
    config: {
      "title": "Завдання - Редагувати",
      "layout": "default",
      "resourceKey": "Task.Task"
    },
    component: Component136
  },
  {
    path: "/applications",
    componentName: "UniversalResourcePage",
    key: "Transportation.Application",
    group: "resource",
    template: "default",
    isResourceGenerated: true,
    config: {
      "title": "Ід - Список",
      "layout": "default",
      "resourceKey": "Transportation.Application"
    },
    component: Component137
  },
  {
    path: "/applications/create",
    componentName: "UniversalResourcePage",
    key: "Transportation.Application.create",
    group: "resource",
    template: "default",
    isResourceGenerated: true,
    config: {
      "title": "Ід - Створити",
      "layout": "default",
      "resourceKey": "Transportation.Application"
    },
    component: Component138
  },
  {
    path: "/applications/:id",
    componentName: "UniversalResourcePage",
    key: "Transportation.Application.view",
    group: "resource",
    template: "default",
    isResourceGenerated: true,
    config: {
      "title": "Ід - Перегляд",
      "layout": "default",
      "resourceKey": "Transportation.Application"
    },
    component: Component139
  },
  {
    path: "/applications/:id/edit",
    componentName: "UniversalResourcePage",
    key: "Transportation.Application.edit",
    group: "resource",
    template: "default",
    isResourceGenerated: true,
    config: {
      "title": "Ід - Редагувати",
      "layout": "default",
      "resourceKey": "Transportation.Application"
    },
    component: Component140
  },
  {
    path: "/trips",
    componentName: "UniversalResourcePage",
    key: "Transportation.Trip",
    group: "resource",
    template: "default",
    isResourceGenerated: true,
    config: {
      "title": "Рейси - Список",
      "layout": "default",
      "resourceKey": "Transportation.Trip"
    },
    component: Component141
  },
  {
    path: "/trips/create",
    componentName: "UniversalResourcePage",
    key: "Transportation.Trip.create",
    group: "resource",
    template: "default",
    isResourceGenerated: true,
    config: {
      "title": "Рейси - Створити",
      "layout": "default",
      "resourceKey": "Transportation.Trip"
    },
    component: Component142
  },
  {
    path: "/trips/:id",
    componentName: "UniversalResourcePage",
    key: "Transportation.Trip.view",
    group: "resource",
    template: "default",
    isResourceGenerated: true,
    config: {
      "title": "Рейси - Перегляд",
      "layout": "default",
      "resourceKey": "Transportation.Trip"
    },
    component: Component143
  },
  {
    path: "/trips/:id/edit",
    componentName: "UniversalResourcePage",
    key: "Transportation.Trip.edit",
    group: "resource",
    template: "default",
    isResourceGenerated: true,
    config: {
      "title": "Рейси - Редагувати",
      "layout": "default",
      "resourceKey": "Transportation.Trip"
    },
    component: Component144
  },
  {
    path: "/requests",
    componentName: "UniversalResourcePage",
    key: "Transportation.Request",
    group: "resource",
    template: "default",
    isResourceGenerated: true,
    config: {
      "title": "Запити - Список",
      "layout": "default",
      "resourceKey": "Transportation.Request"
    },
    component: Component145
  },
  {
    path: "/requests/create",
    componentName: "UniversalResourcePage",
    key: "Transportation.Request.create",
    group: "resource",
    template: "default",
    isResourceGenerated: true,
    config: {
      "title": "Запити - Створити",
      "layout": "default",
      "resourceKey": "Transportation.Request"
    },
    component: Component146
  },
  {
    path: "/requests/:id",
    componentName: "UniversalResourcePage",
    key: "Transportation.Request.view",
    group: "resource",
    template: "default",
    isResourceGenerated: true,
    config: {
      "title": "Запити - Перегляд",
      "layout": "default",
      "resourceKey": "Transportation.Request"
    },
    component: Component147
  },
  {
    path: "/requests/:id/edit",
    componentName: "UniversalResourcePage",
    key: "Transportation.Request.edit",
    group: "resource",
    template: "default",
    isResourceGenerated: true,
    config: {
      "title": "Запити - Редагувати",
      "layout": "default",
      "resourceKey": "Transportation.Request"
    },
    component: Component148
  },
  {
    path: "/tenders",
    componentName: "UniversalResourcePage",
    key: "Transportation.Tender",
    group: "resource",
    template: "default",
    isResourceGenerated: true,
    config: {
      "title": "Тендер - Список",
      "layout": "default",
      "resourceKey": "Transportation.Tender"
    },
    component: Component149
  },
  {
    path: "/tenders/create",
    componentName: "UniversalResourcePage",
    key: "Transportation.Tender.create",
    group: "resource",
    template: "default",
    isResourceGenerated: true,
    config: {
      "title": "Тендер - Створити",
      "layout": "default",
      "resourceKey": "Transportation.Tender"
    },
    component: Component150
  },
  {
    path: "/tenders/:id",
    componentName: "UniversalResourcePage",
    key: "Transportation.Tender.view",
    group: "resource",
    template: "default",
    isResourceGenerated: true,
    config: {
      "title": "Тендер - Перегляд",
      "layout": "default",
      "resourceKey": "Transportation.Tender"
    },
    component: Component151
  },
  {
    path: "/tenders/:id/edit",
    componentName: "UniversalResourcePage",
    key: "Transportation.Tender.edit",
    group: "resource",
    template: "default",
    isResourceGenerated: true,
    config: {
      "title": "Тендер - Редагувати",
      "layout": "default",
      "resourceKey": "Transportation.Tender"
    },
    component: Component152
  }
]

export default generatedRoutes
